import moment from "moment";
import {SALES_SUMMARY_DETAILS} from "../data/constants";
import { SaleSummaryModel } from "./sale-summary-model";
export class SaleSummarySchema {
  SchemaData: any;
  constructor(values: any) {
    this.SchemaData = this.updateSaleSummary(values);
  }

  private updateSaleSummary(values: any) {
    let discountList: SaleSummaryModel[] = [],
      accountList: SaleSummaryModel[] = [],
      netSaleList: SaleSummaryModel[] = [],
      chargeList: SaleSummaryModel[] = [],
      taxList: SaleSummaryModel[] = [],
      paymentList: SaleSummaryModel[] = [],
      channelList: SaleSummaryModel[] = [],
      brandList: SaleSummaryModel[] = [];

    // All list Model
    discountList = this.getDiscountModel(values);
    accountList = this.getAccountSummary(values);
    netSaleList = this.getNetSaleModel(values);
    chargeList = this.getChargeSummaryModel(values);
    taxList = this.geTaxListModel(values);
    paymentList = this.getPaymentSummaryModel(values);
    channelList = this.getChannelSummaryModel(values);
    brandList = this.getBrandSummaryModel(values);

    let dataModal: any = {
      branchData: {
        fields: [
          new SaleSummaryModel(SALES_SUMMARY_DETAILS.GROSS_SALES, values?.grossAmount),
          new SaleSummaryModel(SALES_SUMMARY_DETAILS.SALES_RETURN, values?.returnAmount),
          new SaleSummaryModel(SALES_SUMMARY_DETAILS.DISCOUNTS, values?.discountTotal),
          new SaleSummaryModel(SALES_SUMMARY_DETAILS.DIRECT_CHARGES, values?.directChargeTotal),
          new SaleSummaryModel(SALES_SUMMARY_DETAILS.NET_SALES, values?.netAmount),
          new SaleSummaryModel(SALES_SUMMARY_DETAILS.OTHER_CHARGES, values?.chargeTotal),
          new SaleSummaryModel(SALES_SUMMARY_DETAILS.TAXES, values?.taxTotal),
          new SaleSummaryModel(SALES_SUMMARY_DETAILS.ROUNDING, values?.roundOffTotal),
          new SaleSummaryModel(SALES_SUMMARY_DETAILS.TIP, values?.tipTotal),
          new SaleSummaryModel(SALES_SUMMARY_DETAILS.TOTAL_REVENUE, values?.revenue),
          this.getTotalValueModel(SALES_SUMMARY_DETAILS.PAYMENTS, values.paymentTotal, true),
          this.getTotalValueModel(SALES_SUMMARY_DETAILS.BALANCE_DUE, values.balanceAmount, false),
        ],
      },
    };

    if (discountList.length) {
      dataModal["discount"] = {
        label: SALES_SUMMARY_DETAILS.DISCOUNT_SUMMARY,
        fields: discountList,
      };
    }

    dataModal["netSale"] = {
      label: SALES_SUMMARY_DETAILS.NET_SALE_SUMMARY,
      fields: netSaleList,
    };

    if (chargeList.length) {
      dataModal["chargeList"] = {
        label: SALES_SUMMARY_DETAILS.CHARGE_SUMMARY,
        fields: chargeList,
      };
    }

    if (taxList.length) {
      dataModal["taxList"] = {
        label: SALES_SUMMARY_DETAILS.TAX_SUMMARY,
        fields: taxList,
      };
    }

    if (paymentList.length) {
      dataModal["paymentList"] = {
        label: SALES_SUMMARY_DETAILS.PAYMENT_SUMMARY,
        fields: paymentList,
      };
    }

    if (accountList.length) {
      dataModal["accountList"] = {
        label: SALES_SUMMARY_DETAILS.ACCOUNT_SUMMARY,
        fields: accountList,
      };
    }

    if (channelList.length) {
      dataModal["channelList"] = {
        label: SALES_SUMMARY_DETAILS.CHANNEL_SUMMARY,
        fields: channelList,
      };
    }

    if (brandList.length) {
      dataModal["brandList"] = {
        label: SALES_SUMMARY_DETAILS.BRAND_SUMMARY,
        fields: brandList,
      };
    }
    return dataModal;
  }

  private getDiscountModel(values: any) {
    let listArr: SaleSummaryModel[] = [];
    if (values?.discountList?.length) {
      values.discountList.forEach((discount: any) => {
        listArr.push(
          new SaleSummaryModel(discount.discountCode, discount.amount)
        );
      });
      if (values?.discountTotal) {
        const totalAmount: SaleSummaryModel = this.getTotalValueModel(
          SALES_SUMMARY_DETAILS.DISCOUNT_TOTAL,
          values?.discountTotal,
          true
        );
        listArr.push(totalAmount);
      }
    }
    return listArr;
  }

  private geTaxListModel(values: any) {
    let listArr: SaleSummaryModel[] = [];
    if (values?.taxList?.length) {
      values.taxList.forEach((taxItem: any) => {
        listArr.push(new SaleSummaryModel(taxItem.taxName, taxItem.amount));
      });
      if (values?.taxTotal) {
        const totalAmount: SaleSummaryModel = this.getTotalValueModel(
          SALES_SUMMARY_DETAILS.TAX_TOTAL,
          values.taxTotal,
          true
        );
        listArr.push(totalAmount);
      }
    }
    return listArr;
  }

  private getNetSaleModel(values: any) {
    let listArr: SaleSummaryModel[] = [];
    if (values?.categoryList?.length) {
      values.categoryList.forEach((category: any) => {
        listArr.push(
          new SaleSummaryModel(category.categoryName, category.amount)
        );
      });
    }
    const totalAmount: SaleSummaryModel = this.getTotalValueModel(
      SALES_SUMMARY_DETAILS.NET_SALES_TOTAL,
      values.netAmount,
      true
    );
    listArr.push(totalAmount);
    return listArr;
  }

  private getAccountSummary(values: any) {
    let listArr: SaleSummaryModel[] = [];
    if (values?.accountList?.length) {
      values.accountList.forEach((accountItem: any) => {
        listArr.push(
          new SaleSummaryModel(accountItem.accountName, accountItem.amount)
        );
      });
    }
    return listArr;
  }

  private getChargeSummaryModel(values: any) {
    let listArr: SaleSummaryModel[] = [];
    if (values?.chargeList?.length) {
      values.chargeList.forEach((chargeItem: any) => {
        listArr.push(
          new SaleSummaryModel(chargeItem.chargeName, chargeItem.amount)
        );
      });
      if (values?.chargeTotal) {
        const totalAmount: SaleSummaryModel = this.getTotalValueModel(
          SALES_SUMMARY_DETAILS.CHARGE_TOTAL,
          values.chargeTotal,
          true
        );
        listArr.push(totalAmount);
      }
    }
    return listArr;
  }

  private getPaymentSummaryModel(values: any) {
    let listArr: SaleSummaryModel[] = [];
    if (values?.paymentList?.length) {
      values.paymentList.forEach((paymentItem: any) => {
        listArr.push(
          new SaleSummaryModel(paymentItem.paymentMode, paymentItem.amount)
        );
      });
      if (values?.dayPaymentTotal) {
        const totalAmount: SaleSummaryModel = this.getTotalValueModel(
          SALES_SUMMARY_DETAILS.PAYMENT_TOTAL,
          values.dayPaymentTotal,
          true
        );
        listArr.push(totalAmount);
      }
    }
    return listArr;
  }

  private getChannelSummaryModel(values: any) {
    let listArr: SaleSummaryModel[] = [];
    if (values?.channelList?.length) {
      values.channelList.forEach((channelItem: any) => {
        listArr.push(
          new SaleSummaryModel(channelItem.channelName, channelItem.amount)
        );
      });
    }
    return listArr;
  }

  private getBrandSummaryModel(values: any) {
    let listArr: SaleSummaryModel[] = [];
    if (values?.bizBrandList?.length) {
      values.bizBrandList.forEach((brandItem: any) => {
        listArr.push(
          new SaleSummaryModel(brandItem.bizBrandName, brandItem.amount)
        );
      });
    }
    return listArr;
  }

  private getTotalValueModel(
    keyName: string,
    amount: string,
    extraSpace: boolean
  ) {
    const dataObj = new SaleSummaryModel(keyName, amount);
    dataObj.setHighligthLabel(true);
    if (extraSpace) {
      dataObj.setExtraSpace(true);
    }
    return dataObj;
  }

}

export const getPreviousDate = (daysToSubtract: any = 1) => {
  return moment().subtract(daysToSubtract, "days");
};

export const DateCollection = [
  {
    key: moment().format("YYYY-MM-DD"),
    value: moment().format("DD-MMM-YYYY"),
  },
  {
    key: getPreviousDate(1).format("YYYY-MM-DD"),
    value: getPreviousDate(1).format("DD-MMM-YYYY"),
  },
];
